export function getDeclension(
  count: number,
  forms: readonly [one: string, few: string, many: string],
): string {
  const n = Math.abs(Math.trunc(count)) % 100;
  const n1 = n % 10;

  if (n > 10 && n < 20) {
    return forms[2];
  }
  if (n1 > 1 && n1 < 5) {
    return forms[1];
  }
  if (n1 === 1) {
    return forms[0];
  }

  return forms[2];
}

export function formatCountWithDeclension(
  count: number,
  forms: readonly [one: string, few: string, many: string],
): string {
  return `${count} ${getDeclension(count, forms)}`;
}
